import { dbuiV1WarehouseStartMutation } from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export type WarehouseStartState = {
  attempts: number;
  lastAttemptTime: number;
  lastSuccessTime: number;
  isStarting: boolean;
  error?: Error;
};

export const useCreateStartWarehouseById = () => {
  const { workspace } = useWorkspace();
  return useMutation({
    // Accept the state so we can pass it to update functions on success or error
    // This ensures closures dont pick up older or newer state
    mutationFn: ({ id }: { id: string; state?: WarehouseStartState }) =>
      dbuiV1WarehouseStartMutation({
        ...defaultOptions(),
      }).mutationFn!({ path: { workspace, id } }),
  });
};
